<template>
	<div class="cart-container" @click="close">
		<!-- <transition name="fade"> -->
			<div class="cart-content" v-if="cartOpen">
				<div class="cart-top" style="overflow-y: auto; min-height: 80%;">
					<h2 class="heading">Cart</h2>
					<h3 style="text-align:center;font-size:25px;margin-top:20%;font-family: 'Raleway', sans-serif;" v-if="cart.length === 0"> Your Cart is empty!</h3>
					<ul>
						<li v-for="item in cart" class="cart-item">
							<div class="cart-item-top" :data-item="item.id" @click="editItem">
								<h3 class="tertiary-heading cart-item-top--name">{{ item.name }}</h3>
								<h4 class="tertiary-heading cart-item-top--quantity">x {{ item.qty }}</h4>
								<h4 class="tertiary-heading cart-item-top--price">${{ item.price }}</h4>
								<div class="cart-item-top--buttons">
									<button @click="removeItem" :data-item="item.id" class="delete-item"></button>
								</div>
							</div>
							<div class="cart-item-bottom">
								<h4 class="primary-copy" v-if="item.desc !== item.name">{{ item.desc }}</h4>
								<h4 class="primary-copy special-instructions" v-if="item.specialInstructions">({{ item.specialInstructions }})</h4>
							</div>
						</li>
					</ul>
				</div>
				<div class="cart-bottom">
					<div class="cart-total">
						<h2 class="subheading cart-total-copy">Subtotal:</h2>
						<h2 class="tertiary-heading cart-total-number">${{ total }}</h2>
					</div>
					<div class="cart-buttons">
						<button class="checkout primary-button" @click="handleCheckout" v-if="this.cart.length > 0">Checkout</button>
					</div>
				</div>
			</div>
		<!-- </transition> -->
	</div>
</template>

<script>
	export default {
		name: 'Cart',
		props: ['cartOpen'],
		methods: {
			close (e) {
				if (e.target.classList.contains('cart-container')) {
					this.$emit('close')
				}
			},
			editItem (e) {
				if (!e.target.classList.contains('delete-item')) {
					let itemId = parseInt(e.target.parentNode.dataset.item)
					this.$emit('edit', itemId)
				}
			},
			removeItem (e) {
				let itemId = parseInt(e.target.dataset.item)
				this.$emit('remove', itemId)
			},
			handleCheckout () {
				this.$emit('checkout')
			}
		},
		computed: {
			cart () {
				return this.$root.cart
			},
			total () {
				let total = 0
				this.cart.forEach((item) => {
					total = total + parseFloat(item.price) * parseFloat(item.qty)
				})
				return total.toFixed(2)
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '../assets/css/main';	
	.cart-bottom {
		margin-bottom: 20px;
	}
	.checkout{
		background-color: white;
		color: $primary-color;
	}
	.cart-container {
		display: flex;
		justify-content: flex-end;
		background: linear-gradient( rgba(0,0,0,0.5), rgba(0,0,0,0.5));
	}

	.cart-content {
		width: 50%;
		background: $secondary-color;
		padding-top: 100px;
		padding-left: 2%;
		padding-right: 2%;
		color: white;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		.heading {
			color: white;
		}
		@media (max-width: 500px) {
			width: 100%;
		}
	}

	.cart-item {
		display: flex;
		flex-direction: column;
		margin-bottom: 2%;
		padding: 15px;
	}

	.cart-item:hover {
		cursor:pointer;
		background: lighten($secondary-color, 10%);
	}

	.cart-item-top, .cart-total {
		display: grid;
		grid-template-columns: 10% 50% 20% 20%;
		grid-template-areas: 'buttons item quantity price';
	}

	.cart-item-top .tertiary-heading {
		font-size: 2.2rem;
		text-align: left;
	}

	.cart-item-top .tertiary-heading:nth-child(3) {
		text-align: right;
	}

	.cart-item-top--name {
		grid-area: item;
	}

	.cart-item-top--quantity {
		grid-area: quantity;
	}

	.cart-item-top--price {
		grid-area: price;
	}

	.cart-item-top--buttons {
		display: flex;
		justify-content: space-between;
		align-items: center;
		grid-area: buttons;
		font-size: 2.4rem;
		margin-left: 20%;
		position: relative;
		button {
			width: 3rem;
			height: 3rem;
			background-color: white;
			padding: 0;
		}
		.delete-item:before {
			content: '\f00d';
			font-family: 'FontAwesome';
			color: $primary-color;
		}
	}

	.cart-item-bottom {
		display: flex;
		flex-direction: column;
	}

	.cart-total .tertiary-heading {
		font-size: 2.4rem;
	}

	.cart-total-copy {
		grid-area: buttons, item;
	}

	.cart-total-number {
		grid-area: price;
		text-align: right;
		font-size: 3.4rem !important;
		margin-top: -15px !important;
	}

	.primary-button {
		width: 100%;
		@include primary-font(2.4rem, 700);
		text-align: center;
		padding: 2%;
		border: 1px solid white;
		margin-bottom: 5%;
	}
	.subheading {
		color: white;
	}
</style>


// WEBPACK FOOTER //
// src/components/Cart.vue